'use client'
import { Prisma } from '@prisma/client'
import React, { useEffect, useMemo } from 'react'
import FilterVentesDepartement from '../Select/FilterVentesDepartement'
import FilterVentesRegion from '../Select/FilterVentesRegion'
import MoreSearch from './MoreSearch'
import { setCookieSearch } from '@/app/_server/SearchCookie'
import FilterVentesVille from '../Select/FilterVentesVille'

type Props = {
    tgis: Prisma.TgiGetPayload<{}>[]
    regions: Prisma.RegionsGetPayload<{
      include: {
        departements: true;
      };
    }>[]
    departements: Prisma.DepartementsGetPayload<{}>[]
    typesBiens: Prisma.VentesTypeGetPayload<{}>[]
    searchParams: URLSearchParams
}

const MainSearch = ({ tgis, regions, departements, typesBiens, searchParams }: Props) => {

  const paramsString = useMemo(() => new URLSearchParams(searchParams).toString(), [searchParams]);

  useEffect(() => {
    async function setCookie() {
      await setCookieSearch(paramsString)
    }
    setCookie()
  }, [paramsString])
  
  return (
    <>
        <label >Filtrer par :</label>
        <div className="flex flex-col w-full lg:flex-row justify-between items-center lg:space-x-4 space-y-4 lg:space-y-0 mt-2">
            <FilterVentesRegion regions={regions} searchParams={searchParams} />
            <FilterVentesDepartement regions={regions} departements={departements} searchParams={searchParams}/>
            <FilterVentesVille regions={regions} departements={departements} searchParams={searchParams}/>
        </div>
        <MoreSearch typesBiens={typesBiens} tgis={tgis}/>
    </>
  )
}

export default MainSearch